module.exports = __webpack_public_path__ + "img/excel_icon.eaabd2c9.svg";